import { render, staticRenderFns } from "./SXP.vue?vue&type=template&id=135114bd"
import script from "./SXP.vue?vue&type=script&lang=js"
export * from "./SXP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports